/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { DataTable, DataTableRowToggleEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Link, useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import {
  convertDateToEpoch,
  convertEpochToDateTime,
  convertUTCEpochToDate,
} from "../../../../helper/DateConverters";
import { tableHeaderTemplate } from "../../Work Time Log Management/common/TimeLogTemplates";
// import CalendarDateSelector from "../../Work Time Log Management/common/CalendarDateSelector";
import { fetchAllJobSheetGloucesterForms } from "./fetchData";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import axios from "../../../../util/axiosconfig";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { ROLES } from "../../../../util/roleNameConstants";
import { Calendar } from "primereact/calendar";
import CalendarDateSelector from "../CalendarDateSelector";
import { EditButtonSVG } from "../../../../assets/SVGs/EditButtonSVG";
import { DeleteIconSVG } from "../../../../assets/SVGs/DeleteIconSVG";
import { DeletePopupTrashIcon } from "../../../../assets/SVGs/DeletePopupTrashIcon";
import { ConfirmDialog } from "primereact/confirmdialog";

const GloucesterFormListing = () => {
  const [expandedRows, setExpandedRows] = useState<any>([]);
  const [jobSheetGloucesterForms, setJobSheetGloucesterForms] = useState<any>(
    []
  );
  const [invoicePopupType, setInvoicePopupType] = useState<string | null>("add");
  const [jobSheetGloucesterFormsLoading, setJobSheetGloucesterFormsLoading] =
    useState<boolean>(false);

  const [filters, setFilters] = useState<any>({
    startDate: null,
    endDate: null,
  });
  const toast = useRef<Toast>(null);

  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [addInvoiceNoVisible, setAddInvoiceNoVisible] = useState(false);
  const [addInvoiceNoSubmitting, setAddInvoiceNoSubmitting] = useState(false);
  const [showExportDialog, setShowExportDialog] = useState<boolean>(false);
  const [dateIssued, setDateIssued] = useState<any>(null);
  const [formType, setFormType] = useState<string>("add");
  const [formValues, setFormValues] = useState<any>({
    dateIssued: null,
    invoiceNo: null,
    invoiceValue: null,
  });

  const [showExportOptionsDialog, setShowExportOptionsDialog] =
    useState<boolean>(false);
  const [exportSubmitting, setExportSubmitting] = useState<boolean>(false);

  const [formErrors, setFormErrors] = useState<any>({
    dateIssued: null,
    invoiceNo: null,
    invoiceValue: null,
  });

  const [isConfirmDeleteDialogOpen, setIsConfirmDeleteDialogOpen] =
    useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [isDeleteSubmitting, setIsDeleteSubmitting] = useState(false);

  const navigation = useNavigate();

  const actionBodyTemplate = (rowData: any) => (
    <div className="tw-flex tw-gap-4">
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
        onClick={(e) => {
          e.stopPropagation();
          navigate(
            `/layout/health-and-safety/edit-jobsheet-gloucester?formID=${rowData.id}`
          );
        }}
        // tooltip="Edit"
      >
        <EditButtonSVG />
      </Button>
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
        onClick={(e) => {
          e.stopPropagation();
          setDeleteId(rowData.id);
          setIsConfirmDeleteDialogOpen(true);
        }}
        // tooltip="Delete"
      >
        <DeleteIconSVG />
      </Button>
    </div>
  );

  const handleDelete = async () => {
    try {
      setIsDeleteSubmitting(true);
      const response = await axios.post(
        `health-and-safety/delete-gloucester-job-sheet-form?gloucesterID=${deleteId}`
      );

      if (response.data.StatusCode !== 200) {
        showError("Failed to delete form", toast);
        return;
      }

      showSuccess("Form deleted successfully", toast);
      setIsConfirmDeleteDialogOpen(false);
      setDeleteId(null);

      // Refresh the data
      fetchAllJobSheetGloucesterForms(
        setJobSheetGloucesterForms,
        setJobSheetGloucesterFormsLoading,
        filters,
        toast
      );
    } catch (error) {
      const err = getErrorMessage(error);
      showError(err, toast);
    } finally {
      setIsDeleteSubmitting(false);
    }
  };

  useEffect(() => {
    if (filters.startDate && filters.endDate) {
      fetchAllJobSheetGloucesterForms(
        setJobSheetGloucesterForms,
        setJobSheetGloucesterFormsLoading,
        filters,
        toast
      );
    }
  }, [filters?.startDate, filters.endDate]);

  useEffect(() => {
    if (jobSheetGloucesterForms.length > 0) {
      setExpandedRows([jobSheetGloucesterForms[0]]); // Set the first row as expanded
    }
  }, [jobSheetGloucesterForms]);

  const amelioStaffBodyTemplate = (rowData: any) => {
    return (
      <div className="tw-flex tw-items-center tw-gap-2 hover:tw-bg-[#E8F9FF] tw-p-2 tw-cursor-pointer  ">
        <div className="tw-text-gray-700 tw-text-base tw-font-semibold tw-cursor-pointer  tw-max-w-full">
          {rowData?.formJson?.amelioStaff?.map((staff: any, index: number) => (
            <span
              key={index}
              className=" tw-w-full tw-break-words tw-whitespace-normal"
            >
              {staff.displayName}
              {index < rowData.formJson.amelioStaff.length - 1 ? ", " : ""}
            </span>
          ))}
        </div>
      </div>
    );
  };

  const amelioIDBodyTemplate = (rowData: any) => {
    return (
      <div className="tw-text-gray-700 tw-text-sm tw-font-medium">
        {rowData?.amelioID || ""}
      </div>
    );
  };

  const jobOrderNoBodyTemplate = (rowData: any) => {
    return (
      <div className="tw-text-gray-700 tw-text-sm tw-font-medium">
        {rowData?.formJson?.jobOrderNo || ""}
      </div>
    );
  };

  const navigate = useNavigate();

  // Custom error template (can also include icons or custom components)
  const emptyMessageTemplate = (
    <div style={{ textAlign: "center", fontSize: "1.25rem" }}>
      <h4>No records found.</h4>
    </div>
  );

  const getDisplayDate = (epochValue: any): Date | null => {
    if (!epochValue) return null;
    if (epochValue instanceof Date) return epochValue;
    if (typeof epochValue === "number") {
      return new Date(epochValue * 1000);
    }
    return null;
  };

  const handleInputChange = (field: string, value: any) => {
    setFormValues((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleTimeChange = (name: string, value: any) => {
    // Convert time values to UTC epoch for time fields
    const timeField = "dateIssued";

    let processedValue = value;
    if (timeField === name && value instanceof Date) {
      processedValue = convertDateToEpoch(value);
    }

    setFormValues((prev: any) => ({
      ...prev,
      [name]: processedValue,
    }));
  };

  const validateForm = () => {
    const errors: any = {};
    if (!formValues?.dateIssued) {
      errors.dateIssued = "Date Issued is required";
    }
    if (!formValues?.invoiceNo || formValues.invoiceNo.trim() === "") {
      errors.invoiceNo = "Invoice No is required";
    }
    if (!formValues?.invoiceValue || formValues?.invoiceValue.trim() === "") {
      errors.invoiceValue = "Invoice Value is required";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSaveInvoiceNo = async () => {
    try {
      if (!validateForm()) {
        return;
      }

      const params: any = { formID: selectedRow.id, formKey: "gloucester" };

      if (formValues?.invoiceNo) {
        params.invoiceNo = formValues.invoiceNo.trim();
      }
      if (formValues?.invoiceValue) {
        params.invoiceValue = formValues.invoiceValue.trim();
      }
      if (formValues?.dateIssued) {
        params.dateIssued = formValues.dateIssued;
      }

      setAddInvoiceNoSubmitting(true);
      const response: any = await axios.post(
        `health-and-safety/add-invoice-no`,
        params
      );

      if (response.data.StatusCode !== 200) {
        showError("Failed to save Invoice No", toast);
        return;
      }

      showSuccess(
        response.data.Message || "Invoice No saved successfully",
        toast
      );
      setFormErrors({
        dateIssued: null,
        invoiceNo: null,
        invoiceValue: null,
      });
      setFormValues({
        dateIssued: null,
        invoiceNo: null,
        invoiceValue: null,
      });
      setDateIssued(null);
      // Reset error state
      setAddInvoiceNoVisible(false);
      setSelectedRow(null);
      // Reset error state
      fetchAllJobSheetGloucesterForms(
        setJobSheetGloucesterForms,
        setJobSheetGloucesterFormsLoading,
        filters,
        toast
      );
      setAddInvoiceNoSubmitting(false);
    } catch (error) {
      const err = getErrorMessage(error);
      setAddInvoiceNoSubmitting(false);
      showError(err, toast);
      // return;
    }
    // if (invoiceNoInput) {
    //   // Logic to save the invoice number
    //   alert(
    //     `Invoice No: ${invoiceNoInput} saved for ${selectedRow?.amelioID}`
    //   );
    //   selectedRow.formJson.invoiceNo = invoiceNoInput;
    //   setJobSheetGloucesterForms((prev: any) =>
    //     prev.map((item: any) =>
    //       item.id === selectedRow.id
    //         ? { ...item, formJson: selectedRow.formJson }
    //         : item
    //     )
    //   );
    //   toast.current?.show({
    //     severity: "success",
    //     summary: "Success",
    //     detail: "Invoice No saved successfully",
    //   });
    // }
    // setInvoiceNoInput(null);
  };

  const handleCancelInvoiceNo = () => {
    setInvoicePopupType("add");
    setAddInvoiceNoVisible(false);
    setSelectedRow(null);
    setFormValues({
      dateIssued: null,
      invoiceNo: null,
      invoiceValue: null,
    });
    setFormErrors({
      dateIssued: null,
      invoiceNo: null,
      invoiceValue: null,
    });
    setDateIssued(null);
    // Reset error state
    setAddInvoiceNoSubmitting(false);
  };

  const footerContent = (
    <div className="tw-w-full ">
      {formType === "add" && (
        <Button
          label="Submit"
          type="submit" // Ensure the button type is "submit"
          disabled={addInvoiceNoSubmitting} // Disable the button while loading
          loading={addInvoiceNoSubmitting} // Show loading spinner when loading
          onClick={handleSaveInvoiceNo} // Call the form submission function
          className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-primary tw-border-primary tw-text-white tw-font-medium tw-w-full"
        />
      )}
    </div>
  );
  const handleExport = () => {
    setShowExportOptionsDialog(true);
  };

  const handleExportOption = async (withImages: boolean) => {
    try {
      setExportSubmitting(true);

      const response = await axios.get(
        `health-and-safety/gloucester-timesheet-pdf?startDate=${filters?.startDate}&endDate=${filters?.endDate}&isImage=${withImages}`
      );

      if (response.data.StatusCode !== 202) {
        showError("Failed to load PDF HTML content", toast);
        return;
      }
    } catch (err) {
      console.error("Failed to load PDF HTML content", err);
      const errorMessage = getErrorMessage(err);
      showError(errorMessage, toast);
    } finally {
      setShowExportOptionsDialog(false);
      setShowExportDialog(true);
      setExportSubmitting(false);
    }
  };

  const handleViewInvoiceDetails = (rowData: any) => {
    setFormValues({
      dateIssued: rowData?.dateIssued || null,
      invoiceNo: rowData?.invoiceNo || null,
      invoiceValue: rowData?.invoiceValue || null,
    });
    setSelectedRow(rowData);
    setAddInvoiceNoVisible(true);
    setDateIssued(getDisplayDate(rowData?.dateIssued));
    // setInvoiceNoInput(rowData?.invoiceNo || "");
    setFormErrors({
      dateIssued: null,
      invoiceNo: null,
      invoiceValue: null,
    });
  };

  return (
    <>
      <Toast ref={toast} />
      {/* Export Options Dialog */}
      <Dialog
        visible={showExportOptionsDialog}
        onHide={() => !exportSubmitting && setShowExportOptionsDialog(false)}
        header="Export Options"
        style={{ width: "400px" }}
        closable={!exportSubmitting}
        draggable={false}
      >
        <div className="tw-p-4">
          <p className="tw-mb-6 tw-text-gray-700">
            Please select your export preference:
          </p>
          <div className="tw-flex tw-flex-col tw-gap-3">
            <Button
              label="Export with Images"
              icon="pi pi-image"
              onClick={() => handleExportOption(true)}
              disabled={exportSubmitting}
              loading={exportSubmitting}
              className="tw-w-full tw-p-3 tw-bg-primary tw-border-primary tw-text-white tw-font-medium focus:tw-shadow-none"
            />
            <Button
              label="Export without Images"
              icon="pi pi-file-text"
              onClick={() => handleExportOption(false)}
              disabled={exportSubmitting}
              className="tw-w-full tw-p-3 tw-bg-gray-600 tw-border-gray-600 tw-text-white tw-font-medium focus:tw-shadow-none"
            />
          </div>
          {!exportSubmitting && (
            <div className="tw-mt-4 tw-pt-4 tw-border-t tw-border-gray-200">
              <Button
                label="Cancel"
                onClick={() => setShowExportOptionsDialog(false)}
                className="tw-w-full tw-p-2 tw-bg-white tw-border tw-border-gray-300 tw-text-gray-700 tw-font-medium focus:tw-shadow-none hover:tw-bg-gray-50"
              />
            </div>
          )}
        </div>
      </Dialog>

      {/* Success Dialog */}
      <Dialog
        visible={showExportDialog}
        onHide={() => setShowExportDialog(false)}
        header="✅ Successful"
      >
        <div>
          Your export generation has started. You can view the progress in the
          'Forms Export History' tab. To access it please {""}
          <Link
            to="/layout/health-and-safety/forms-export-history"
            className="tw-text-primary tw-underline hover:tw-text-[#152846] tw-font-medium"
            onClick={() => setShowExportDialog(false)}
          >
            click here.
          </Link>
        </div>
      </Dialog>
      <div className=" tw-bg-[#F8FAFC] tw-border-solid tw-border tw-border-[#E2E8F0] tw-rounded-lg">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-4 tw-p-4 tw-gap-2 tw-flex-wrap">
          <h2 className="tw-text-xl tw-font-semibold">
            Job Sheet Gloucester Listing
          </h2>
          <div className="tw-flex tw-gap-2 tw-items-center tw-justify-end tw-flex-wrap">
            <CalendarDateSelector
              setDateRange={setFilters}
              defaultQuickRange="Current Month"
            />
            <Button
              className="tw-flex tw-px-3 tw-py-2 tw-rounded bg-primary border-primary tw-text-white tw-font-medium"
              label="Add"
              icon="pi pi-plus"
              onClick={() =>
                navigate(`/layout/health-and-safety/add-jobsheet-gloucester`)
              }
            />
            {/* {localStorage.roleName.includes(ROLES.HANDS_ADMIN) && (
              <Button
                className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-[#555555] tw-border-[#555555] tw-text-white tw-font-medium focus:tw-shadow-none"
                label="Export"
                icon="pi pi-upload"
                onClick={handleExport}
                // onClick={() =>
                //   invoiceManagement(
                //     page,
                //     filters?.size,
                //     searchWithDebounce,
                //     "export-invoice"
                //   )
                // }
                disabled={jobSheetGloucesterForms.length === 0}
              />
            )} */}
            {localStorage.roleName.includes(ROLES.HANDS_ADMIN) && (
              <Button
                className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-[#555555] tw-border-[#555555] tw-text-white tw-font-medium focus:tw-shadow-none"
                label="Export"
                icon="pi pi-upload"
                onClick={handleExport}
                disabled={
                  jobSheetGloucesterForms.length === 0 || exportSubmitting
                }
                loading={exportSubmitting}
              />
            )}
          </div>
        </div>

        {/* <Button
              className="tw-flex tw-px-3 tw-py-2 tw-rounded bg-white tw-text-black tw-border-solid tw-border tw-border-black tw-font-medium"
              label="Export PDF"
              icon="pi pi-file-pdf"
              onClick={handleExport}
            /> */}
        {jobSheetGloucesterFormsLoading ? (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
            <ProgressSpinner />
          </div>
        ) : (
          <DataTable
            value={jobSheetGloucesterForms}
            emptyMessage={emptyMessageTemplate}
            rowGroupMode="subheader"
            groupRowsBy="formDate"
            expandableRowGroups
            expandedRows={expandedRows}
            onRowToggle={(e: DataTableRowToggleEvent) => {
              setExpandedRows(e.data);
            }}
            tableStyle={{ minWidth: "50rem" }}
            rowGroupHeaderTemplate={(data: any) => {
              return (
                <div className="tw-inline-flex tw-justify-between tw-items-center tw-gap-3 table-row-group-header tw-bg-[#F8FAFC] tw-pl-2 tw-tex tw-font-semibold tw-text-base tw-text-[#64748B]">
                  {convertUTCEpochToDate(data.formDate)}
                </div>
              );
            }}
            onRowClick={(e) => {
              const rowData = e.data;
              navigation(
                `/layout/health-and-safety/view-jobsheet-gloucester?formID=${rowData.id}`
              );
            }}
            rowClassName={() =>
              "hover:tw-bg-[#E8F9FF] tw-cursor-pointer tw-text-[#64748B]"
            }
            className="a-table timelog-datatable tw-text-nowrap tw-text-sm tw-text-[#64748B]"
            style={{ backgroundColor: "#000 !important" }}
          >
            <Column
              field="amelioStaff"
              header={tableHeaderTemplate("Amelio Staff", "")}
              body={amelioStaffBodyTemplate}
              style={{ maxWidth: "250px" }}
            />
            <Column
              field="amelioID"
              header={tableHeaderTemplate("Amelio ID", "")}
              body={amelioIDBodyTemplate}
            />
            <Column
              field="jobOrderNo"
              header={tableHeaderTemplate("Job Order No", "")}
              body={jobOrderNoBodyTemplate}
              style={{ maxWidth: "150px" }}
            />
            <Column
              field="clientName"
              header={tableHeaderTemplate("Client Name", "")}
              body={(rowData) => {
                return (
                  <div className="tw-text-gray-700 tw-text-sm tw-font-medium tw-break-words tw-whitespace-normal">
                    {rowData?.formJson?.clientName || "N/A"}
                  </div>
                );
              }}
              style={{ maxWidth: "200px" }}
              // body={clientNameBodyTemplate}
            />
            <Column
              field="siteAddress"
              header={tableHeaderTemplate("Site Address", "")}
              body={(rowData) => {
                return (
                  <div className="tw-text-gray-700 tw-text-sm tw-font-medium tw-break-words tw-whitespace-normal">
                    {rowData?.formJson?.siteAddress || "N/A"}
                  </div>
                );
              }}
              style={{ maxWidth: "200px" }}
            />
            {localStorage.roleName.includes(ROLES.HANDS_ADMIN) && (
              <Column
                field="invoiceNo"
                header={tableHeaderTemplate(
                  "Invoice Details",
                  ""
                )}
                body={(rowData) => {
                  const invoiceNo = rowData?.invoiceNo;
                  return (
                    <div className="tw-text-gray-700 tw-text-sm tw-font-medium">
                      {invoiceNo ? (
                        <span className="tw-break-words tw-whitespace-normal">
                          <Button
                            label={`View`}
                            icon="pi pi-eye"
                            // onClick={() => setShowAddJobNumber(true)}
                            onClick={(e) => {
                              e.stopPropagation();
                              setFormType("view");
                              setInvoicePopupType("view");
                              handleViewInvoiceDetails(rowData);
                            }}
                            // disabled={invoiceDetailsLoading}
                            className={`tw-border-gray-700 tw-border tw-border-solid  tw-w-fit tw-px-2 tw-py-1 tw-text-sm tw-font-semibold focus:tw-shadow-none tw-mt-2`}
                            // className="tw-text-blue-500 tw-text-sm tw-font-semibold"
                            text
                          />
                        </span>
                      ) : (
                        <Button
                          icon="pi pi-plus"
                          label="Add"
                          className="tw-p-2 tw-text-xs focus:tw-shadow-none tw-bg-primary tw-border-primary tw-text-white"
                          tooltip="Add Invoice Details"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedRow(rowData);
                            setFormType("add");
                            setInvoicePopupType("add");
                            setAddInvoiceNoVisible(true);
                            // Add your logic to handle adding invoice number here
                          }}
                        />
                      )}
                    </div>
                  );
                }}
                style={{ maxWidth: "150px" }}
              />
            )}
            <Column
              field="Created On"
              header={tableHeaderTemplate("Created On", "")}
              body={(rowData) => {
                return (
                  <div className="tw-text-gray-700 tw-text-sm tw-font-medium">
                    <span className="">
                      {new Date(rowData.createdDate).toLocaleTimeString(
                        "en-EN",
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        }
                      )}
                    </span>
                  </div>
                );
              }}
            />
            {localStorage.roleName.includes(ROLES.HANDS_ADMIN) && (
              <Column
                field="action"
                header={tableHeaderTemplate("Actions", "")}
                body={actionBodyTemplate}
                style={{ maxWidth: "120px" }}
              />
            )}
          </DataTable>
        )}
      </div>
      <Dialog
        header={
          invoicePopupType === "add"
            ? "Add Invoice Details"
            : "View Invoice Details"
        }
        visible={addInvoiceNoVisible}
        onHide={handleCancelInvoiceNo}
        closable
        draggable={false}
        footer={footerContent}
        style={{ width: "500px" }} // Fixed width for consistency
        // Added class for custom styling
        //  style={{
        //   // Tailwind: border-b, bg-gray-50 for header; remove padding for content
        //   // But Dialog's header/content are not directly accessible via style prop
        //  }}
        className="invoice-dialog [&_.p-dialog-header]:tw-border-b [&_.p-dialog-header]:tw-bg-gray-50 [&_.p-dialog-content]:tw-p-0"
      >
        <div className="tw-flex tw-flex-col tw-gap-6 tw-w-full tw-p-4">
          {/* Information section with card-like appearance */}
          <div className="tw-bg-gray-50 tw-rounded-lg tw-p-4 tw-border tw-border-gray-200">
            <div className="tw-grid tw-grid-cols-1 tw-gap-4">
              {/* Amelio ID */}
              <div className="tw-flex tw-flex-col">
                <label className="tw-text-sm tw-font-medium tw-text-gray-500">
                  Amelio ID
                </label>
                <div className="tw-text-base tw-font-semibold tw-text-gray-800 tw-mt-1">
                  {selectedRow?.amelioID || (
                    <span className="tw-text-base tw-font-semibold tw-text-gray-800 tw-mt-1">
                      N/A
                    </span>
                  )}
                </div>
              </div>

              {/* Amelio Staff */}
              <div className="tw-flex tw-flex-col">
                <label className="tw-text-sm tw-font-medium tw-text-gray-500">
                  Amelio Staff
                </label>
                <div className="tw-flex tw-flex-wrap tw-gap-1 tw-mt-1">
                  {selectedRow?.formJson?.amelioStaff?.length ? (
                    selectedRow.formJson.amelioStaff.map(
                      (staff: any, index: number) => (
                        <div
                          key={index}
                          className="tw-text-base tw-font-semibold tw-text-gray-800 tw-mt-1"
                        >
                          {staff.displayName}
                          {index < selectedRow.formJson.amelioStaff.length - 1
                            ? ","
                            : ""}
                        </div>
                      )
                    )
                  ) : (
                    <span className="tw-text-base tw-font-semibold tw-text-gray-800 tw-mt-1">
                      N/A
                    </span>
                  )}
                </div>
              </div>

              {/* Client Name */}
              <div className="tw-flex tw-flex-col">
                <label className="tw-text-sm tw-font-medium tw-text-gray-500">
                  Client Name
                </label>
                <div className="tw-text-base tw-font-semibold tw-text-gray-800 tw-mt-1">
                  {selectedRow?.formJson?.clientName || (
                    <span className="tw-text-base tw-font-semibold tw-text-gray-800 tw-mt-1">
                      N/A
                    </span>
                  )}
                </div>
              </div>

              {/* Job Order No */}
              <div className="tw-flex tw-flex-col">
                <label className="tw-text-sm tw-font-medium tw-text-gray-500">
                  Job Order No
                </label>
                <div className="tw-text-base tw-font-semibold tw-text-gray-800 tw-mt-1">
                  {selectedRow?.formJson?.jobOrderNo || (
                    <span className="tw-text-base tw-font-semibold tw-text-gray-800 tw-mt-1">
                      N/A
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Invoice No input with better focus state */}
          <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
            <label className="leak-label">
              Date Issued <span className="tw-text-red-500">*</span>
            </label>
            {formType === "add" ? (
              <Calendar
                value={getDisplayDate(dateIssued)}
                onChange={(e) => {
                  setDateIssued(e.value);
                  handleTimeChange("dateIssued", e.value);
                  setFormErrors((prev: any) => ({
                    ...prev,
                    dateIssued: null, // Clear error on change
                  }));
                }}
                disabled={addInvoiceNoSubmitting}
                placeholder="Select Date Issued"
                showIcon
                showTime
                dateFormat="dd-mm-yy"
                hourFormat="24"
                className={`tw-pl-3 tw-py-2 tw-border ${
                  formErrors?.dateIssued
                    ? "tw-border-red-500"
                    : "tw-border-gray-300"
                } tw-rounded-md tw-text-gray-700 tw-h-11 tw-w-full focus:tw-ring-2 focus:tw-ring-blue-200 focus:tw-border-blue-500 focus:tw-outline-none transition-colors`}
              />
            ) : (
              <InputText
                value={convertEpochToDateTime(formValues?.dateIssued) ?? ""}
                readOnly
                placeholder={formType === "view" ? "N/A" : "Select Date Issued"}
                className={`tw-pl-3 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-gray-700 tw-h-11 tw-w-full focus:tw-ring-2 focus:tw-ring-blue-200 focus:tw-border-blue-500 focus:tw-outline-none transition-colors`}
              />
            )}
            {/* {formErrors?.dateIssued && (
              <div className="tw-text-sm tw-text-red-600 tw-mt-1">
                {formErrors?.dateIssued}
              </div>
            )} */}
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2">
            <label className="leak-label">
              Invoice No <span className="tw-text-red-500">*</span>
            </label>
            <InputText
              value={formValues?.invoiceNo ?? ""}
              onChange={(e) => {
                handleInputChange("invoiceNo", e.target.value);
                // setInvoiceNoInput(e.target.value);
                setFormErrors((prev: any) => ({
                  ...prev,
                  invoiceNo: null, // Clear error on change
                }));
              }}
              readOnly={formType === "view"}
              disabled={addInvoiceNoSubmitting}
              placeholder={formType === "view" ? "N/A" : "Enter Invoice No"}
              className={`tw-pl-3 tw-py-2 tw-border ${
                formErrors?.invoiceNo
                  ? "tw-border-red-500"
                  : "tw-border-gray-300"
              } tw-rounded-md tw-text-gray-700 tw-h-11 tw-w-full focus:tw-ring-2 focus:tw-ring-blue-200 focus:tw-border-blue-500 focus:tw-outline-none transition-colors`}
            />
            {/* {formErrors?.invoiceNo && (
              <div className="tw-text-sm tw-text-red-600 tw-mt-1">
                {formErrors?.invoiceNo}
              </div>
            )} */}
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2">
            <label className="leak-label">
              Invoice Value <span className="tw-text-red-500">*</span>
            </label>
            <InputText
              value={formValues?.invoiceValue ?? ""}
              onChange={(e) => {
                handleInputChange("invoiceValue", e.target.value);
                setFormErrors((prev: any) => ({
                  ...prev,
                  invoiceValue: null, // Clear error on change
                }));
              }}
              readOnly={formType === "view"}
              disabled={addInvoiceNoSubmitting}
              placeholder={formType === "view" ? "N/A" : "Enter Invoice Value"}
              className={`tw-pl-3 tw-py-2 tw-border ${
                formErrors?.invoiceValue
                  ? "tw-border-red-500"
                  : "tw-border-gray-300"
              } tw-rounded-md tw-text-gray-700 tw-h-11 tw-w-full focus:tw-ring-2 focus:tw-ring-blue-200 focus:tw-border-blue-500 focus:tw-outline-none transition-colors`}
            />
            {/* {formErrors?.invoiceValue && (
              <div className="tw-text-sm tw-text-red-600 tw-mt-1">
                {formErrors?.invoiceValue}
              </div>
            )} */}
          </div>
        </div>
      </Dialog>

      <ConfirmDialog
        group="headless"
        visible={isConfirmDeleteDialogOpen}
        onHide={() => setIsConfirmDeleteDialogOpen(false)}
        message={
          <div className="tw-flex tw-flex-align-items-center tw-w-full tw-gap-3 tw-border-bottom-1 tw-surface-border">
            <DeletePopupTrashIcon />
            <div className="tw-flex tw-flex-col">
              <span className="tw-text-2xl tw-font-bold tw-text-black">
                Confirmation
              </span>
              <span className="tw-text-lg">
                Are you sure you want to delete this job sheet?
              </span>
            </div>
          </div>
        }
        footer={() => (
          <div className="flex gap-2">
            <Button
              onClick={() => setIsConfirmDeleteDialogOpen(false)}
              className="tw-rounded-lg tw-border tw-border-gray-300 tw-px-4 focus:tw-shadow-none hover:tw-bg-gray-200 tw-py-2 tw-font-medium tw-transition-all tw-duration-200"
              disabled={isDeleteSubmitting}
            >
              Cancel
            </Button>
            <Button
              onClick={handleDelete}
              className="tw-bg-primary hover:tw-bg-[#152846] tw-text-white focus:tw-shadow-none tw-rounded-lg tw-px-4 tw-py-2 tw-ml-2 tw-font-medium tw-transition-all tw-duration-200"
              disabled={isDeleteSubmitting}
              // loading={isDeleteSubmitting}
            >
              Delete
            </Button>
          </div>
        )}
      />
    </>
  );
};

export default GloucesterFormListing;
